import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, mediaUrl } from "../lib/api";
import { Plus, MessageSquare, Send } from "lucide-react";
import { toast } from "sonner";

const HelpBoard = () => {
    const [items, setItems] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [form, setForm] = useState({ title: "", description: "", category: "" });
    const [active, setActive] = useState(null);
    const [reply, setReply] = useState("");

    const load = async () => {
        try {
            const { data } = await api.get("/help");
            setItems(data);
        } catch {}
    };
    useEffect(() => { load(); }, []);

    const submit = async (e) => {
        e.preventDefault();
        try {
            await api.post("/help", form);
            setForm({ title: "", description: "", category: "" });
            setShowForm(false);
            load();
            toast.success("Richiesta pubblicata");
        } catch { toast.error("Errore"); }
    };

    const sendReply = async () => {
        if (!reply.trim() || !active) return;
        try {
            await api.post(`/help/${active.id}/reply`, { text: reply });
            setReply("");
            load();
            const { data } = await api.get("/help");
            const updated = data.find((h) => h.id === active.id);
            if (updated) setActive(updated);
            toast.success("Risposta inviata");
        } catch { toast.error("Errore"); }
    };

    return (
        <div className="max-w-4xl mx-auto" data-testid="help-page">
            <div className="flex items-start justify-between mb-6 flex-wrap gap-4">
                <div>
                    <h1 className="font-heading text-4xl">Bacheca aiuti</h1>
                    <p className="text-sm text-muted mt-1">Hai bisogno di una mano? Chiedi alla rete.</p>
                </div>
                <button data-testid="new-help" onClick={() => setShowForm(!showForm)} className="btn-primary text-sm"><Plus size={14} /> Nuova richiesta</button>
            </div>

            {showForm && (
                <form onSubmit={submit} className="bg-paper rounded-2xl border border-border-line p-6 mb-6 space-y-3 fade-up">
                    <input required placeholder="Titolo (es. Cerco un commercialista a Milano)" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="input-clean" data-testid="help-title" />
                    <input required placeholder="Categoria (es. Consulenza, Marketing, Tech)" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="input-clean" data-testid="help-cat" />
                    <textarea required placeholder="Descrivi la tua richiesta…" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="input-clean min-h-[120px]" data-testid="help-desc" />
                    <button className="btn-primary" data-testid="help-submit">Pubblica</button>
                </form>
            )}

            {active ? (
                <div className="bg-paper rounded-2xl border border-border-line p-6 fade-up">
                    <button onClick={() => setActive(null)} className="text-xs text-muted hover:text-ink mb-4">← Torna alla bacheca</button>
                    <div className="text-xs text-bordeaux uppercase tracking-widest">{active.category}</div>
                    <h2 className="font-heading text-3xl mt-2">{active.title}</h2>
                    <div className="text-xs text-muted mt-1">di <Link to={`/profile/${active.user?.id}`} className="hover:underline text-ink">{active.user?.full_name}</Link></div>
                    <p className="mt-4 text-ink whitespace-pre-wrap leading-relaxed">{active.description}</p>
                    <div className="mt-8 border-t border-border-line pt-6">
                        <h3 className="text-xs uppercase tracking-widest text-muted mb-3">Risposte ({active.replies?.length || 0})</h3>
                        <div className="space-y-3">
                            {active.replies?.map((r) => (
                                <div key={r.id} className="bg-surface rounded-xl p-4">
                                    <Link to={`/profile/${r.user_id}`} className="text-sm font-medium hover:underline">{r.user_name}</Link>
                                    <p className="text-sm mt-1">{r.text}</p>
                                </div>
                            ))}
                        </div>
                        <div className="flex gap-2 mt-4">
                            <input value={reply} onChange={(e) => setReply(e.target.value)} placeholder="Offri una mano…" className="input-clean" data-testid="reply-input" />
                            <button onClick={sendReply} className="btn-primary" data-testid="reply-send"><Send size={14} /></button>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="space-y-4">
                    {items.length === 0 && <div className="text-center py-12 text-muted">Nessuna richiesta. Sii il primo.</div>}
                    {items.map((h) => (
                        <button key={h.id} onClick={() => setActive(h)} className="block w-full text-left bg-paper rounded-2xl border border-border-line soft-shadow-sm p-5 hover:-translate-y-0.5 transition-transform" data-testid={`help-item-${h.id}`}>
                            <div className="text-xs text-bordeaux uppercase tracking-widest">{h.category}</div>
                            <div className="font-heading text-xl mt-1">{h.title}</div>
                            <div className="text-sm text-muted mt-2 line-clamp-2">{h.description}</div>
                            <div className="flex items-center justify-between mt-4 text-xs text-muted">
                                <span>di {h.user?.full_name}</span>
                                <span className="flex items-center gap-1"><MessageSquare size={12} /> {h.reply_count} risposte</span>
                            </div>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default HelpBoard;
